import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  visitLabel: string;
  isSaving: boolean;
  onConfirm: (reason: string | null) => void;
};

export function CancelVisitDialog({
  open,
  onOpenChange,
  visitLabel,
  isSaving,
  onConfirm,
}: Props): React.JSX.Element {
  const [reason, setReason] = useState("");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Cancelar visita</DialogTitle>
          <DialogDescription>
            Se cancelará la visita del {visitLabel}. El lead y el asesor
            recibirán la notificación de cancelación.
          </DialogDescription>
        </DialogHeader>

        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          maxLength={255}
          rows={2}
          placeholder="Motivo (opcional)"
          className="w-full rounded-lg border border-ink-200 px-3 py-2 text-sm text-ink-800 placeholder:text-ink-300 focus:border-moss focus:outline-none"
        />

        <DialogFooter>
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)}>
            Volver
          </Button>
          <Button
            variant="destructive"
            size="sm"
            disabled={isSaving}
            onClick={() => onConfirm(reason.trim() === "" ? null : reason.trim())}
          >
            {isSaving ? "Cancelando…" : "Cancelar visita"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
